import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { STACK_ROLE_BINDING_UPDATE } from "./gql";

const useStackRoleBindingUpdate = createDefaultMutationHook(STACK_ROLE_BINDING_UPDATE);

export default useStackRoleBindingUpdate;
